<template>
  <div>
    <Filters
      v-model="filterParams"
      :catalogs="{
        divisions,
        users,
      }"
      :loading="loading"
      :editMode="editMode"
      @editDivision="editDivision"
      @deleteDivision="deleteDivision"
    />
    <DivisionSchema
      v-if="currentDivision.id"
      v-model="currentDivision"
      :editMode="editMode"
      :catalogs="{
        users,
      }"
    />
    <loading-content
      v-else
      md-rounded
      empty-icon="category"
      empty-label="Seleccione una división"
      :loading="loading"
    />
    {{ currentDivision }}
  </div>
</template>
<script>
import { Modal } from "@/components";
import Filters from "./Filters";
import DivisionSchema from "./DivisionSchema";

import { debounce, cloneDeep } from "lodash";

export default {
  name: "DivisionsIndex",
  components: { Modal, Filters, DivisionSchema },

  data() {
    return {
      divisions: [
        {
          supervisors: [
            {
              email: "cdmx7@jgbe.com.mx",
              first_name: "CDMX7 - Víctor David",
              groups: [{ name: "Supervisor" }],
              id: 1,
              is_active: true,
              last_name: "Arroyo",
              mothers_last_name: "González",
              photo:
                "https://jbsiniestros.mx/media/static/img/default/Users/photo_default.jpg",
              treatment: "C.",
              username: "cdmx7",
            },
            {
              email: "cdmx7@jgbe.com.mx",
              first_name: "CDMX7 - Víctor David",
              groups: [{ name: "Supervisor" }],
              id: 2,
              is_active: true,
              last_name: "Arroyo",
              mothers_last_name: "González",
              photo:
                "https://jbsiniestros.mx/media/static/img/default/Users/photo_default.jpg",
              treatment: "C.",
              username: "cdmx7",
            },
            {
              email: "cdmx7@jgbe.com.mx",
              first_name: "CDMX7 - Víctor David",
              groups: [{ name: "Supervisor" }],
              id: 3,
              is_active: true,
              last_name: "Arroyo",
              mothers_last_name: "González",
              photo:
                "https://jbsiniestros.mx/media/static/img/default/Users/photo_default.jpg",
              treatment: "C.",
              username: "cdmx7",
            },
            {
              email: "cdmx7@jgbe.com.mx",
              first_name: "CDMX7 - Víctor David",
              groups: [{ name: "Supervisor" }],
              id: 4,
              is_active: true,
              last_name: "Arroyo",
              mothers_last_name: "González",
              photo:
                "https://jbsiniestros.mx/media/static/img/default/Users/photo_default.jpg",
              treatment: "C.",
              username: "cdmx7",
            },
          ],
          id: 2,
          leader: {
            email: "cdmx7@jgbe.com.mx",
            first_name: "CODI 2 - María de Lourdes",
            is_active: true,
            last_name: "Arroyo",
            mothers_last_name: "González",
            photo:
              "https://jbsiniestros.mx/media/static/img/default/Users/photo_default.jpg",
            treatment: "C.",
            id: 11,
            groups: [{ name: "CoDi" }],
            username: "codi_division2",
          },
          name: "División 2",
          slug: "division-2",
        },
      ],
      filterParams: {},
      currentDivision: {},
      users: [],

      loading: true,
      editMode: false,
    };
  },
  methods: {
    editDivision() {
      this.editMode = !this.editMode;
    },
    deleteDivision() {
      this.$confirmMessage(
        {
          title: `¿Realmente desea borrar ${this.currentDivision.name}?`,
        },
        () => {}
      );
    },
  },
  watch: {
    filterParams: debounce(function () {}, 100),
    "filterParams.division": {
      handler(newVal) {
        const current = this.divisions.find(({ id }) => id === newVal);
        this.currentDivision = current || {};
      },
    },
  },
  // mounted() {
  //   Promise.all([])
  //     .then(() => {})
  //     .catch(this.$fireErrorResponse)
  //     .finally(() => (this.loading = false));
  // },
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/pages/Catalogs/Divisions/index.vue